var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5833 27H26.6666C24.8543 27 23.1162 27.7112 21.8347 28.977C20.5532 30.2429 19.8333 31.9598 19.8333 33.75V81C19.8333 82.7902 20.5532 84.5071 21.8347 85.773C23.1162 87.0388 24.8543 87.75 26.6666 87.75H74.4999C76.3122 87.75 78.0503 87.0388 79.3318 85.773C80.6133 84.5071 81.3333 82.7902 81.3333 81V57.375",
    stroke: "#043263",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2082 21.9383C77.5675 20.5956 79.411 19.8413 81.3332 19.8413C83.2555 19.8413 85.099 20.5956 86.4582 21.9383C87.8175 23.2809 88.5811 25.102 88.5811 27.0008C88.5811 28.8996 87.8175 30.7206 86.4582 32.0633L53.9999 64.1258L40.3333 67.5008L43.7499 54.0008L76.2082 21.9383Z",
    fill: "#043263",
    stroke: "#043263",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.2a83718abc48dd4ab99034fb28801ebf.svg";
export { ForwardRef as ReactComponent };